import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const Title = styled.h1`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-weight: 600;
    color: #000;
    padding: 66px 0 0 33px;
    margin-bottom: 25px;
    font-size: 44px;

    @media screen and (max-width: 1919px) {
        font-size: 30px; 
        padding: 48px 0 0 33px;
    }  
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        padding: 33px 0 0 33px;
        font-size: 20px;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        margin-bottom: 0;
    }
`;

export const StyledImg = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    img {
        width: 80%;
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        margin-bottom: 0;
        img {
        width: 100%;
        height: 75%;
    }
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        margin: 0 auto;
        img {
        min-width: 300px;
        min-height: 300px;
    }
    }
`;

export const BoxReport = styled.div`
    background-color: #fff;
    padding: 0 50px;
    margin-top: 30px;
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        padding: 0 30px;
  }
`;
